<template>
    <div class="container">
        <common-top-form :model="formModel" :show="false" :submitService="submitService" :submitData="submitData" @success="onSuccess">
            <el-form-item label="通道名称">
                <el-select v-model="formModel.chnCode">
                    <el-option
                        v-for="item in chnCodes"
                        :key="item.chnCode"
                        :label="item.chnName"
                        :value="item.chnCode">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="进件状态">
                <el-select v-model="formModel.status">
                    <el-option
                        v-for="item in status"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="有效状态">
                <el-select v-model="formModel.deleteStatus">
                    <el-option
                        v-for="item in deleteStatus"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey">
                    </el-option>
                </el-select>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" :isShow="false">
            <el-table-column prop="tatName" label="进件机构" min-width="150" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="chnName" label="进件通道" min-width="150" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="cardNo" label="结算卡号" min-width="200" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="busCode" label="业务编码" min-width="150" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="merCode" label="商户编号" min-width="200" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="status" label="进件状态" min-width="150" show-overflow-tooltip :formatter="formatterStatus"></el-table-column>
            <el-table-column prop="deleteStatus" label="有效状态" min-width="150" show-overflow-tooltip :formatter="formatterDelStatus"></el-table-column>
            <el-table-column prop="resMsg" label="响应信息" min-width="150" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="160" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="editor" label="修改人" min-width="150" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
            <el-table-column prop="editTime" label="修改时间" min-width="160" show-overflow-tooltip :formatter="formatterTableData"></el-table-column>
            <el-table-column label="操作" min-width="200" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" @click="reissueNotice(scope.row)">
                        {{scope.row.deleteStatus == 0 ? '禁用' : '启用'}}
                    </el-button>
                    <el-button type="text" @click="handleBalance(scope.row)" v-if="scope.row.deleteStatus == 0 && scope.row.status == 2">重进件</el-button>
                </template>
            </el-table-column>
        </common-table>
    </div>
</template>

<script>
    import CommonTable from 'components/common/CommonTable'
    import TimeRange from 'service/constant/TimeRange'
    import CommonTopForm from 'components/common/CommonTopForm'
    import TransactionService from 'service/TransactionService'
    import ChannelService from 'service/ChannelService'
    import CardStatus from 'service/constant/CardStatus'
    import CardDeleteStatus from 'service/constant/CardDeleteStatus'
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from 'vuex'
    export default {
        name: "importinfo",
        components: {
            CommonTable, CommonTopForm
        },
        data(){
            return{
                formModel:{
                    chnCode: '',
                    status: '',
                    deleteStatus: '',
                },
                tableData:[],
                chnCodes:[],
                dialogAmount: '',
                submitService: TransactionService.findAllByIdCard,
                status:CardStatus,
                deleteStatus:CardDeleteStatus
            }
        },
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted(){
            this.getchnNameList();
            this.getList();
        },
        computed: {
            submitData(){
                const params = {
                    userId: this.$route.params.id,
                    chnCode: this.formModel.chnCode,
                    status: this.formModel.status,
                    deleteStatus: this.formModel.deleteStatus
                };
                return params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId'])
        },
        methods:{
            getchnNameList() {
                this.doLoad(ChannelService.names, '', res => {
                    this.doCheck(res, res => {
                        this.chnCodes = [{
                            chnCode: '',
                            chnName: '全部'
                        }, ...res.contents];
                    });
                }, '信息获取失败')
            },
            getList() {
                this.doLoad(this.submitService, this.submitData, res => {
                    this.doCheck(res, res => {
                        this.onSuccess(res);
                    });
                }, '信息获取失败')
            },
            onSuccess(res) {
                this.doCheck(res, res => {
                    const result = res.contents;
                    this.tableData = result;
                });
            },
            reissueNotice(item) {
                this.showConfirm(`确定对该数据进行${item.deleteStatus == 0 ? '禁用' : '启用'}操作？`).then(()=>{
                    this.doSettle(item);
                }).catch(()=>{});
            },
            handleBalance(item){
                this.showConfirm(`确定对该数据进行重进件操作？`).then(()=>{
                    this.doRefresh(item);
                }).catch(()=>{});
            },
            doSettle(item){
                this.doLoad(TransactionService.merInfoToggle, {id : item.id}, res => {
                    this.doCheck(res, res => {
                        this.showSuccess(res.respMsg);
                        this.getList();
                    });
                }, '信息获取失败')
            },
            doRefresh(item){
                this.doLoad(TransactionService.merInfoRefresh, {
                    id : item.id,
                    userId: this.$route.params.id,
                }, res => {
                    this.doCheck(res, res => {
                        this.showSuccess(res.respMsg);
                        this.getList();
                    });
                }, '信息获取失败')
            },
            formatterStatus(row, column, cellValue, index){
                let value = '';
                this.status.forEach(item => {
                    if (item.dictKey == cellValue) {
                        value = item.dictValue
                    }
                });
                return value == '' ? '--' : value;
            },
            formatterDelStatus(row, column, cellValue, index){
                let value = '';
                this.deleteStatus.forEach(item => {
                    if (item.dictKey == cellValue) {
                        value = item.dictValue
                    }
                });
                return value == '' ? '--' : value;
            },
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/fragment/MemberManage/ImportInfo.vue